<template>
    <b-modal :id="modalId" :ref="modalId" size="sm" title="Serial Numbers">
        <p>Select the serial number that are being shipped to add the shipped box, or scan the serial numbers that are being shipped.</p>
        <div style="display: grid; grid-template-rows: repeat(3, 1fr); grid-template-columns: repeat(3, 1fr); grid-column-gap: 0.75rem;">
            <div style="grid-area: 1/1/4/1" class="box">
                <b-form-group>
                    <b-form-checkbox-group
                        :options="availableSN"
                        v-model="availableCheckedSN"
                        value-field="id"
                        text-field="serialNumber"
                        stacked
                    ></b-form-checkbox-group>
                </b-form-group>
            </div>
            <div style="grid-area: 2/2/auto/auto; padding: 5px;">
                <b-button class="mb-1" @click="transferSerialNumbers(true)">
                    <i class="fa fa-angle-right fa-fw"></i>
                </b-button>
                <b-button @click="transferSerialNumbers(false)">
                    <i class="fa fa-angle-left fa-fw"></i>
                </b-button>
            </div>
            <div style="grid-area: 1/3/4/3" class="box">
                <b-form-group>
                    <b-form-checkbox-group
                        :options="selectedSN"
                        v-model="selectedCheckedSN"
                        value-field="id"
                        text-field="serialNumber"
                        stacked
                    ></b-form-checkbox-group>
                </b-form-group>
            </div>
        </div>
        <template slot="modal-footer">
            <b-button variant="primary" class="mr-auto"> Scan</b-button>
            <!-- <b-button @click="$bvModal.hide(modalId)">Close</b-button> -->
            <b-button variant="primary" @click="$bvModal.hide(modalId)">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        serialNumbers: {
            type: Array,
            default: () => []
        },
        modalId: {
            type: String,
            default: 'pick-list-serial-number-modal'
        }
    },
    data: () => ({
        availableCheckedSN: [],
        selectedCheckedSN: [],
        selectedSerialNumbers: [],
    }),
    computed: {
        availableSN() {
            return this.serialNumbers.filter(x => !x.isPickLineItemSelected);
        },
        selectedSN() {
            return this.serialNumbers.filter(x => x.isPickLineItemSelected);
        }
    },
    methods: {
        transferSerialNumbers(isSelected) {
            const checked = isSelected ? this.availableCheckedSN : this.selectedCheckedSN;

            checked.forEach(id => {
                const ndx = this.serialNumbers.findIndex(x => x.id == id);
                if (ndx > -1)
                    this.serialNumbers[ndx].isPickLineItemSelected = isSelected;                
            });

            this.availableCheckedSN = [];
            this.selectedCheckedSN = [];
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
    .box {
        width: 190px;
        padding: 10px;
        border: 1px solid black;
        box-sizing: border-box;
    }
</style>